import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";

import { AdminRouter, WebRouter } from "./router";
import { AuthProvider, CartProvider } from "./contexts";
import { useAuth } from "./hooks";

function AppContent() {
  const { isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  const isAdminPath = location.pathname.startsWith("/admin");

  if (isAdminPath) {
    return <AdminRouter />;
  }

  return <WebRouter />;
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}